import {AbstractStudyComponent} from './abstract-study.component';
import {CategoryName} from './category-name';
import {Observable} from 'rxjs';
import { Directive } from "@angular/core";

@Directive()
export abstract class AbstractParametersStudy extends AbstractStudyComponent<any> {
    protected constructor(category: CategoryName, studyId: Observable<string>) {
        super(category, studyId, false);
    }
}
